"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequireContext = exports.create = exports["default"] = exports.ContextRegistry = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _directory = _interopRequireDefault(require("./directory"));

var hide = function hide(o, p, value, configurable) {
  return Object.defineProperty(o, p, {
    value: value,
    configurable: configurable,
    enumerable: false
  });
};

var ContextRegistry =
/*#__PURE__*/
function (_Directory) {
  (0, _inherits2["default"])(ContextRegistry, _Directory);

  function ContextRegistry(name) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, ContextRegistry);

    if ((0, _typeof2["default"])(name) === 'object') {
      options = name;
      name = options.name || options.context && options.context.id;
    }

    var webpackContext = options.context || options.req;
    delete options.context;
    delete options.req;
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ContextRegistry).call(this, name, options));
    hide((0, _assertThisInitialized2["default"])(_this), 'context', _this.wrapContext(webpackContext, (0, _objectSpread3["default"])({}, options, {
      namespace: _this.keyNamespace
    })));

    if (options.auto !== false) {
      _this.registerContextModules();
    }

    return _this;
  }

  (0, _createClass2["default"])(ContextRegistry, [{
    key: "isValidContext",
    value: function isValidContext(obj) {
      return typeof obj === 'function' && typeof obj.keys === 'function' && typeof obj.resolve === 'function';
    }
  }, {
    key: "add",
    value: function add(webpackContext) {
      var _this2 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isValidContext(webpackContext) && webpackContext.convertToRequireContext) {
        webpackContext = webpackContext.convertToRequireContext();
      } else if ((0, _typeof2["default"])(webpackContext) === 'object' && !webpackContext.prototype) {
        Object.keys(webpackContext).map(function (id) {
          return _this2.register(id, function () {
            return webpackContext[id];
          });
        });
        return this;
      }

      this.registerContextModules(this.wrapContext(webpackContext, (0, _objectSpread3["default"])({}, this.options, options)));
      return this;
    }
  }, {
    key: "registerContextModules",
    value: function registerContextModules() {
      var _this3 = this;

      var requireContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context;
      var map = requireContext.idsMappedToKeys;
      requireContext.ids.forEach(function (id) {
        _this3.register(id, function () {
          return requireContext.load(id);
        }, (0, _objectSpread3["default"])({
          id: id
        }, requireContext.metaForKey(id), _this3.options));
      });
    }
  }, {
    key: "wrapContext",
    value: function wrapContext(webpackContext) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new RequireContext(webpackContext, (0, _objectSpread3["default"])({}, this.options, options));
    }
  }, {
    key: "keyNamespace",
    get: function get() {
      return this.options.keyNamespace || '';
    }
  }, {
    key: "loaded",
    get: function get() {
      this.registerContextModules();
      return this;
    }
  }]);
  return ContextRegistry;
}(_directory["default"]);

exports.ContextRegistry = ContextRegistry;
var _default = ContextRegistry;
exports["default"] = _default;

var create = function create() {
  return ContextRegistry.create.apply(ContextRegistry, arguments);
};
/**
 * Wraps a particular type of webpack require context with a custom
 * API for using the modules it contains for their intended purpose.
 */


exports.create = create;

var RequireContext =
/*#__PURE__*/
function () {
  /**
   * Wrap one of webpack's require.context objects in your own custom object to provide
   * a DSL for working with that group of modules.
   *
   * @param {Context} webpackRequireContext - the result of a require.context call made inside a webpack compilation
   * @param {Object} options
   * @param {String} options.prefix - a prefix that will be discarded when coming up with a humanized id for the module
   */
  function RequireContext(webpackRequireContext) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, RequireContext);

    if (webpackRequireContext && typeof webpackRequireContext !== 'function' && webpackRequireContext.asRequireContext) {
      webpackRequireContext = webpackRequireContext.asRequireContext;
    }

    if (typeof webpackRequireContext !== 'function') {
      throw "You must pass a the output of webpack's require.context() call.  It should be a function which has a keys method that returns an array of module ids.";
    }

    if (typeof webpackRequireContext.keys !== 'function') {
      throw "You must pass a the output of webpack's require.context() call.  It should be a function which has a keys method that returns an array of module ids.";
    }

    hide(this, 'options', options);
    hide(this, 'req', webpackRequireContext);
  }

  (0, _createClass2["default"])(RequireContext, [{
    key: "metaForKey",
    value: function metaForKey(id) {
      var key = this.idsMappedToKeys[id];
      return {
        id: id,
        key: key,
        resolved: this.req.resolve(key),
        sourceModule: this.sourceModule
      };
    }
  }, {
    key: "load",
    value: function load(id) {
      var key = this.idsMappedToKeys[id];
      return this.req(key);
    } // prefix the id

  }, {
    key: "sourceModule",
    get: function get() {
      return this.options.sourceModule || {};
    }
  }, {
    key: "namespace",
    get: function get() {
      return this.options.namespace || '';
    } // remove this value from the require context key

  }, {
    key: "prefix",
    get: function get() {
      return this.options.prefix ? this.options.prefix : '';
    }
  }, {
    key: "keys",
    get: function get() {
      return this.req.keys();
    }
  }, {
    key: "resolved",
    get: function get() {}
  }, {
    key: "ids",
    get: function get() {
      return Object.keys(this.idsMappedToKeys);
    }
  }, {
    key: "idsMappedToKeys",
    get: function get() {
      var _this4 = this;

      return this.keys.reduce(function (memo, key) {
        return (0, _objectSpread3["default"])({}, memo, (0, _defineProperty2["default"])({}, "".concat(key.replace(/^\.\//, _this4.namespace).replace(_this4.prefix, '').replace(/\.\w+$/, '')), key));
      }, {});
    }
  }]);
  return RequireContext;
}();

exports.RequireContext = RequireContext;